import { DialogButton } from "common/component/SequentialDialog";
import { ClientReportReportTypeMap } from "../../domain";
import { DialogActionData } from "./types";

export const createButton = (
  text: string, 
  data: DialogActionData, 
  color: DialogButton['color'] = 'green',
  minWidth = '130px'
): DialogButton => ({
  text,
  color,
  minWidth,
  onClick: () => {},
  data
});

export const getReportTypeDisplayName = (reportType: string, caseNumber?: string): string => {
  const displayName = ClientReportReportTypeMap.get(reportType) || '';
  return caseNumber ? `${displayName} (${caseNumber})` : displayName;
};

export const getArticle = (text: string): string => {
  return /^[aeiou]/i.test(text) ? 'An' : 'A';
};
